export const normalizePastedJson = (raw) => {
  const trimmed = raw.trim();
  const withoutTrailingCommas = trimmed.replace(/,\s*([\]}])/g, "$1");
  const parsed = JSON.parse(withoutTrailingCommas);
  return Array.isArray(parsed) ? parsed : [parsed];
};

export const parseApplicationRecord = (record) => {
  const applicationId = Number(record.id);
  const jobSeekerId = Number(record.job_seeker_id);
  const jobPositionId = Number(record.job_id);

  if (!applicationId || !jobSeekerId || !jobPositionId) {
    throw new Error(
      `Missing required IDs for application ${record.id ?? "unknown"}`
    );
  }

  const questions = record.questions ?? "[]";
  normalizeQuestions(questions);

  const resumeUrl = record.resume_url?.trim();
  if (!resumeUrl) {
    throw new Error(`Missing resume_url for application ${applicationId}`);
  }

  return {
    application_id: applicationId,
    job_seeker_id: jobSeekerId,
    job_position_id: jobPositionId,
    questions,
    resume_url: resumeUrl,
    file_name: record.file_name?.trim() || "resume.pdf",
  };
};

/**
 * Matches seekers-mobile formatJobPositionDetails in PositionDetailRight.jsx
 */
export const formatJobPositionDetails = (position) => {
  let details = `${position?.title || ""} Position`;

  if (position?.availability) {
    try {
      const availabilityArray = JSON.parse(position.availability);
      if (availabilityArray.length > 0) {
        const availabilityText = availabilityArray
          .map(
            (avail) =>
              avail.charAt(0).toUpperCase() + avail.slice(1).replace("-", " ")
          )
          .join(", ");
        details += ` - ${availabilityText}`;
      }
    } catch {
      // availability may not be JSON
    }
  }

  details += "\n\n";

  if (position?.description) {
    details += `${position.description}\n\n`;
  }

  if (position?.experience) {
    details += "Requirements:\n";
    details += `${position.experience}\n\n`;
  }

  if (position?.availability) {
    try {
      const availabilityArray = JSON.parse(position.availability);
      if (availabilityArray.length > 0) {
        details += "Shifts:\n";
        details += `- Available for ${availabilityArray.join(" and ")} positions\n`;
        details += "- Must be available for all scheduled shifts\n";
        details += "- Holiday availability may be required\n\n";
      }
    } catch {
      // availability may not be JSON
    }
  }

  if (position?.wage) {
    details += `Compensation: ${position.wage}`;
  }

  return details.trim();
};

/**
 * Matches seekers-mobile question shape: [{ question, answer }]
 */
export const normalizeQuestions = (questionsInput) => {
  let parsed = questionsInput ?? [];

  if (typeof parsed === "string") {
    parsed = JSON.parse(parsed);
  }

  if (!Array.isArray(parsed)) {
    throw new Error("questions must be a JSON array");
  }

  const normalized = parsed.map((item) => ({
    question: item?.question || item?.description || "",
    answer: item?.answer || "",
  }));

  return JSON.stringify(normalized);
};

/**
 * Builds the same payload shape as seekers-mobile callScoringAPI().
 */
export const buildScoreApplicantPayload = ({ position, record, resumeText }) => {
  const jobPositionDetails = formatJobPositionDetails(position);

  if (!jobPositionDetails) {
    throw new Error("Job position details are empty");
  }

  if (!resumeText?.trim()) {
    throw new Error("Resume text is empty");
  }

  return {
    jobPositionDetails,
    customRules: position?.ai_preference || "",
    job_position_lat: position?.location?.address?.lat || "",
    job_position_lng: position?.location?.address?.lng || "",
    job_seeker_lat: "",
    job_seeker_lng: "",
    resumeText,
    questions: normalizeQuestions(record.questions),
    application_id: record.application_id,
    job_position_id: record.job_position_id,
    job_seeker_id: record.job_seeker_id,
    language: "en",
  };
};

export const getPositionFromResponse = (positionResponse) =>
  positionResponse?.data?.data ?? positionResponse ?? {};

export { parseResumeFromUrl } from "./resumeParser";
